export const API_USER_IDENTIFIER = 'intakeUserIdentifier'
export const API_TOKEN_VALUE = 'intakeApiToken'
export const API_TOKEN_EXPIRY_DATE = 'intakeApiTokenExpiryDate'
export const APP_SESSION_ID = 'intakeAppSessionId'
export const API_LOCATION = 'intakeApiLocation'
export const AUTH_USER_ROLE = 'intakeUserRole'

let localStore: Storage
let sessionStore: Storage

export function initialize(local: Storage, session: Storage) {
  if (localStore !== undefined || sessionStore !== undefined) {
    console.warn('Storage already initialized')
  }

  localStore = local
  sessionStore = session
}

export function getStore(session = false): Storage {
  return session ? sessionStore : localStore
}

export function key(itemKey: number, session = false): string {
  return getStore(session).key(itemKey)
}

export function getItem(itemKey: string, session = false): string {
  return getStore(session).getItem(itemKey)
}

export function setItem(itemKey: string, value: string, session = false) {
  return getStore(session).setItem(itemKey, value)
}

export function clearItem(itemKey: string, session = false) {
  return getStore(session).removeItem(itemKey)
}

export function reset(session = false) {
  return getStore(session).clear()
}

export function setObject(objectKey: string, value: unknown, session = false) {
  const serializedObject = JSON.stringify(value)
  return getStore(session).setItem(objectKey, serializedObject)
}

export function getObject(objectKey: string, session = false) {
  const serializedObject = getStore(session).getItem(objectKey)
  return JSON.parse(serializedObject ?? '{}')
}
